/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Icon } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button } from 'global/components/Button';
import { CloseButton } from 'global/components/modal/styles';
import { FilterPanelHeader } from 'global/styles/filters';

const DialogHeading = styled(DialogTitle)(({ theme }) => ({
  textAlign: 'center',
  fontSize: 16,
  marginLeft: theme.spacing(3),
  textTransform: 'capitalize',
}));

export default (props) => {
  const { useDialog, title, children, onClose, onClear, open } = props;

  if (useDialog) {
    const includeButtons = props.includeButtons !== false;

    return (
      <Dialog open={open} onClose={onClose} scroll="paper" sx={{ '& .MuiPaper-root': { position: 'relative' } }}>
        <CloseButton onClick={onClose} size="large" aria-label="close" sx={{ zIndex: 1 }}>
          <Icon>close</Icon>
        </CloseButton>

        {title && <DialogHeading>{title}</DialogHeading>}

        <DialogContent>{children}</DialogContent>

        {includeButtons && (
          <DialogActions>
            {onClear && (
              <Button variant="text" onClick={onClear}>
                Clear
              </Button>
            )}
            <Button onClick={onClose}>Apply</Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {title && <FilterPanelHeader>{title}</FilterPanelHeader>}
      {children}
    </div>
  );
};
